import { defineMessages } from 'react-intl';
import { boolean, object, string } from 'yup';

import addressSchema from './address';

const messages = defineMessages({
  acknowledgeLicensed: {
    id: 'reservationPayment.acknowledgeLicensed',
    defaultMessage: 'Attestation required',
  },
  acknowledgeTermsAndConditions: {
    id: 'reservationPayment.acknowledgeLicensed',
    defaultMessage: 'Please review and accept the terms and conditions',
  },
  acknowledgeRenewal: {
    id: 'reservationPayment.acknowledgeRenewal',
    defaultMessage: 'Please acknowledge the renewal policy',
  },
});

export const SourceType = {
  CARD: 'CARD',
  ELECTRONIC_INVOICE: 'ELECTRONIC_INVOICE',
  PAYMENT_REQUEST: 'PAYMENT_REQUEST',
};

const schema = object({
  sourceType: string()
    .oneOf(Object.values(SourceType))
    .required(),

  cardName: string().when('sourceType', {
    is: SourceType.CARD,
    then: string().required(),
  }),
  useShippingAddressAsBillingAddress: boolean()
    .required()
    .default(true),

  billingAddress: addressSchema.when(
    ['sourceType', 'useShippingAddressAsBillingAddress'],
    (sourceType, useShippingAddressAsBillingAddress, billingAddress) =>
      sourceType === SourceType.CARD && !useShippingAddressAsBillingAddress
        ? billingAddress.required()
        : object(),
  ),
  acknowledgeLicensed: boolean()
    .oneOf([true], messages.acknowledgeLicensed)
    .default(false)
    .required(),
  acknowledgeTermsAndConditions: boolean()
    .oneOf([true], messages.acknowledgeTermsAndConditions)
    .default(false)
    .required(),
  acknowledgeRenewal: boolean()
    .oneOf([true], messages.acknowledgeRenewal)
    .default(false)
    .required(),
});

export default schema;
